import FloatingActionButton from "./floatingactionbutton";
import ClientApplicationsSkeleton from "./skeletons/clientapplicationsskeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import InsetAlert from "./insetalert";
import ApplicationListItem from "./applicationlistitem";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import useMessageStore from "../stores/message-store";
import { useApplicationsAdd, useGetApplicationsQuery } from "../new/query";
import { useNavigate, useOutletContext } from "react-router-dom";
import useUserStore from "../stores/user-store";
import { getApplicationLandingPath, hasPermission, permissionPaths } from "../auth/permission-paths";

const ClientApplications = () => {
    const {MedicaidID} = useOutletContext();
    const query = useGetApplicationsQuery(MedicaidID);
    const permissions = useUserStore((state) => state.permissions);

    const addToast = useMessageStore(state => state.addToast);

    const navigate = useNavigate();

    const errorCallback = () => {
            addToast(
                    {
                        id: Math.random(),
                        body: "An error occured when adding the application.",
                        autoHide: true,
                        errorFlag: true,
                        timestamp: Date.now() - 1000
                    }
                )
    }

    const successCallback = () => {
        addToast(
                    {
                        id: Math.random(),
                        body: "The Application was added succesfully!",
                        autoHide: true,
                        errorFlag: false,
                        timestamp: Date.now() - 1000
                    }
                )

    }

    const appAdd = useApplicationsAdd(MedicaidID,successCallback,errorCallback);
    const canAddApplication = hasPermission(permissions, permissionPaths.clientApplications.add);
    const canViewHistory = hasPermission(permissions, permissionPaths.applicationHistory.display);

    const _AddApplication = () => {
        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure you want to create a new application?',
            buttons: [
                    {
                        label: 'Yes',
                        onClick: () => appAdd.mutate({MedicaidID: MedicaidID})
                    },
                    {
                        label: 'No'
                    }
            ]
        })
    }


    return(
        !query.isLoading
        ?
        <div className="clientCard">
            <div className="clientCardInner">
                <div className="d-flex justify-content-between applicationHeader">
                    <h3 className="clientInformationTitle">Applications</h3>
                    {
                        !query.error && canAddApplication
                        ?
                            <FloatingActionButton aria-label="Add Application" type="button" variant="success" onClick={() => _AddApplication()} >
                                <FloatingActionButton.Icon>
                                    <FontAwesomeIcon icon={faPlus} size="lg" />
                                </FloatingActionButton.Icon>
                                <FloatingActionButton.Text>
                                    Add Application
                                </FloatingActionButton.Text>
                            </FloatingActionButton>
                        :
                            null
                    }
                </div>
                {
                    !query.error
                    ?
                        query.data.length > 0
                        ?
                            query.data.map((item,index) => {
                                const landingPath = getApplicationLandingPath(permissions, item.applicationid);

                                return (
                                    <ApplicationListItem
                                        key={index}
                                        appID={item.applicationid}
                                        status={item.applicationstatus}
                                        lastActiveDate={item.applicationlastactivitydate}
                                        creationDate={item.applicationdate}
                                        selectCallback={landingPath ? () => navigate(landingPath,{state: {medicaidid: MedicaidID}}) : null}
                                        navToHistory={canViewHistory ? () => navigate(`/Client/Applications/${item.applicationid}/history`) : null}
                                    />
                                )
                            })
                        :
                            <span className="d-flex justify-content-center">No applications currently exist</span>
                    :
                        <InsetAlert error={query.error} dismissible={false} style={{width: '100%'}}/>
                }
            </div>
        </div>
        :
            <ClientApplicationsSkeleton />
    )
}

export default ClientApplications;
